import { Flex } from 'components/shared/flex'
import { usePostStocktakingApi } from 'api/stocktaking'
import { SelectField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { StocktakingForm } from 'entities/stocktaking'
import { selectMonth, selectYears } from 'utils/util'
import moment from 'moment'

export type FormViewProps = {
    form: Form<StocktakingForm>
    apiError: ApiError
}

const FormView = ({ form, apiError }: FormViewProps) => {
    return (
        <>
            <Flex>
                <SelectField form={form} attr="year" selectItems={selectYears()} label="年" apiError={apiError} />
                <SelectField form={form} attr="month" selectItems={selectMonth()} label="月" apiError={apiError} />
            </Flex>
        </>
    )
}

type NewStocktakingFormProps = {
    onComplete?: () => void
}

export const NewStocktakingForm = (props: NewStocktakingFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostStocktakingApi()
    const form = useForm<StocktakingForm>({ year: Number(moment().format('YYYY')), month: Number(moment().format('M')) })
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>棚卸しの登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <FormView form={form} apiError={api.apiError} />
                    </>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
